// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3v9uR","label":"style_label__-5dgV","defaultInput":"style_defaultInput__3P20y"};